<style scoped lang="less">
@import '../../../style/reset.less'; // 引入公共LESS文件

.detailsTabBox {
  // height: 100px;
  // overflow: hidden;
  // padding: 0 16px;
  // margin: 0 -16px;
}

.detailsTab {
  // height: 100px;
  margin-bottom: 15px;

  .tabTop {
    position: relative;
    margin-top: 15px;
    .flex();

    a {
      display: block;
      padding: 0 10px;
      color: @color_262626;
      font-size: 14px;
      font-family: @font_family_PublicSans_Bold;
      line-height: 21px;
      border-radius: 10px;
      // font-family: @font_family_PublicSans_Regular_bold;

      &.on {
        background: @color_FECD05;
        color: @color_663409;
      }
    }
  }

  .subset {
    border-radius: 15px;
    border: 1px solid @color_FECD05;
    padding: 3px;
    margin-top: 15px;
    .flex();

    a {
      display: block;
      color: @color_595959;
      line-height: 24px;
      padding: 0 20px;
      border-radius: 12px;
      font-family: @font_family_PublicSans_Bold;
      font-size: 12px;
      // margin-right: 8px;
      // height: 22px;
      // padding: 2px 16px;
      // border-radius: 4px;
      // border: 1px solid @color_BFBFBF;
      // // background: @color_bg_FFF;
      // line-height: 22px;

      &.on {
        background: @color_FECD05;
        color: @color_663409;
        font-family: @font_family_PublicSans_Bold;
      }
    }
  }
}

.detailsTabShow {
  height: 41px;
}

.detailsTab_on {
  position: relative;
  height: 41px;
  height: 41px;

  .subset {
    display: none;
  }
}

@media screen and (max-width: 767px) {
  .detailsTabBox {
    // height: 0.78rem;
    // padding: 0;
    // margin: 0;
  }

  .detailsTab {
    // height: 0.78rem;
    margin-bottom: 0;
    padding: 0.12rem 0.12rem 0;
    background:@color_F5F5F5;
    
    &>div{
      display: block!important;
    }

    .tabTop {
      width: 100%;
      overflow-x: auto;
      border-bottom-width: .01rem 0 .01rem;
      margin: 0;
      padding: 0;

      // top:0.44rem;
      &::before {
        display: none;
      }

      &::after {
        content: '';
        display: none;
      }

      &::-webkit-scrollbar {
        width: 0rem;
        display: none !important;
      }

      &::-webkit-scrollbar-thumb {
        /* 设置滚动条手柄颜色 */
      }

      &::-webkit-scrollbar-track {
        /* 设置滚动条轨道颜色 */
      }

      a {
        margin: 0 0.16rem;
        padding: 0 0.01rem;

        font-size: 0.14rem;

        line-height: 0.38rem;

        &.on {}
      }
    }

    .subset {
      border-radius: .15rem;
      border: .01rem solid @color_FECD05;
      width: 100%;
      overflow-x: auto;
      margin-top: 0;
      padding: .03rem;
      width: fit-content;
      
      &::-webkit-scrollbar {
        width: 0rem;
        display: none !important;
      }

      a {
        margin-right: 0;
        height: 0.25rem;
        padding: 0rem 0.13rem;
        border-radius: 0.04rem;
        white-space: nowrap;

        font-size: 0.12rem;
        line-height: 0.25rem;
        font-family: @font_family_PublicSans_Regular;

        &.on {
          border-radius: .12rem;
        }
      }
    }
  }

  .detailsTabShow {
    // height: 0.39rem;
  }

  .detailsTab_on {
    height: 0.38rem;
    margin: 0;
    padding: 0;
    border-bottom: none;
    left: 0;
    top: 0.44rem;
    width: 100%;
    position: fixed;

    &::after {
      &::before {
        width: 100%;
        left: 0;
        bottom: 0;
        height: 0.01rem;
      }
    }
  }

}
</style>
<template>
  <div >
    <div class="detailsTabBox"  :class="(!tabList[tabObj[tabData.tabId].index].child.length>0?'detailsTabShow':'')"> 
      <div class="detailsTab" :class="(isHeadDown?'':'')" v-if="match">
        <!-- <div class="tabTop flex">
          <template v-for="(item, index) in tabList">
          <a href="javascript:void(0);" :class="item.id==tabData.tabId?'on':''" :key="index" @click="onTabChange(
            item.id,
            (item.child.length>0?item.child[0].id:0),
            (item.child.length>0?item.child[0].name:item.name)
            )" v-if="isShow(item.id,0)">
              {{item.name}}
            </a>
          </template>
        </div> -->
        <!-- v-if="tabShow" -->
        <div v-if="tabShow" style="display: inline-block">
          <div class="subset" v-if="tabList[tabObj[tabData.tabId].index].child.length>0">
            <template v-for="(item, index) in tabList[tabObj[tabData.tabId].index].child">
              <a v-show="item.isShow" href="javascript:void(0);" :class="item.id==tabData.childID?'on':''" :key="index" @click="onTabChange(tabList[tabObj[tabData.tabId].index].id,item.id,item.name)" v-if="isShow(tabList[tabObj[tabData.tabId].index].id,item.id)">{{item.name}}</a>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'detailsTab',
  data() {
    return {
      isWeb: true,
      tabList:[
        // {
        //   name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['MATCH'],
        //   id:'1',
        //   child:[
        //     // {
        //     //   name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['SUMMARY'],
        //     //   id:'1',
        //     // },{
        //     //   name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['STATS'],
        //     //   id:'2',
        //     // },{
        //     //   name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['LINEUP'],
        //     //   id:'3',
        //     // },{
        //     //   name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['EVENT'],
        //     //   id:'4',
        //     // },
        //   ]
        // },
        // {
        //   name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['ODDS'],
        //   id:'2',
        //   child:[
        //   ]
        // },
        // {
        //   name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['H2H'],
        //   id:'3',
        //   child:[
        //   ]
        // },
        // {
        //   name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['STANDING'],
        //   id:'4',
        //   child:[
        //   ]
        // },
        // {
        //   name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['PREDICTION'],
        //   id:'5',
        //   child:[
        //     {
        //       name: 'Poisson',
        //       id:'9',
        //     },{
        //       name: 'Margin',
        //       id:'10',
        //     },{
        //       name: 'Divergence',
        //       id:'11',
        //     },
        //   ]
        // },
        {
          name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['PREDICTION'],
          id:'5',
          child:[
            {
              name: '1x2',
              id:'1',
              isShow: true,
            },
            {
              name: 'Asian Handicap',
              id:'2',
              isShow: true,
            },
            {
              name: 'Goals Over/Under',
              id:'3',
              isShow: true,
            },
            {
              name: 'Correct Scores',
              id:'4',
              isShow: true,
            },
            {
              name: 'Goals', 
              id:'5',
              isShow: true,
            },
          ]
        },
      ],
      tabData:{// 
        tabId:5,
        childID: this.common.getTabChildId(this),
      },
      tabObj:null,
      tabShow:false,
    }
  },
  methods: { 
    
    //数据转换
    getTabObj(){
      const tabList = JSON.parse(JSON.stringify(this.tabList));
      const tabObj = {};
      tabList.forEach((tabList_i, index) => {
        tabObj[tabList_i.id] = {
          index,
          child: tabList_i.child.reduce((childObj, child_i, childIndex) => {
            childObj[child_i.id] = childIndex;
            return childObj;
          }, {})
        };
      });
      this.tabObj = tabObj;
      //console.log('tabObj',tabObj);
     
      if(this.newTabData){
        this.tabData=this.newTabData;
      }
      this.tabShow=true;
    },
    isShow(tabId,childID){
      var match=JSON.parse(JSON.stringify(this.match));
      if(!match){
        return true;
      }
      let hasLineup=match.hasLineup||false;//是否有阵容 0非1=正式2=预测
      let hasStats=match.hasStats||false;//是否有统计 0非1是
      let hasEventLive=match.hasEventLive||false;//是否有事件直播 0非1是
      let hasLuck=match.hasLuck||false;//是否有指
      let hasPrediction=true||match.hasPrediction||false;//是否有指
      let hasStanding=match.hasStanding||false;//积分版
      
      //console.log('阵容',hasLineup,'Stats统计',hasStats,'直播',hasEventLive,'指数',hasLuck,'积分',hasStanding);
      if(tabId==1&&childID==3&&!hasLineup){
        return false;
      }else if(tabId==1&&childID==2&&!hasStats){
        return false;
      }else if(tabId==1&&childID==4&&!hasEventLive){
        return false;
      }else if(tabId==2&&!hasLuck){
        return false;
      }else if(tabId==5&&!hasPrediction){//tabId==5&&!hasPrediction
        return false;
      }else if(tabId==4&&!hasStanding){//积分版
        return false;
      }
      return true;

    },
    //切换
    onTabChange(tabId,childID,name){
      let tabData={
        tabId:tabId,
        childID:childID,
        name:name
      }

      let eventName = 'LS_PC_MD_ModelSwitch_Click';
      if(this.common.isMobile != 4){
          eventName = 'LS_Webapp_MD_ModelSwitch_Click';
      }
      this.common.googleEvent(eventName, {
        '玩法': this.langConfig.txtLang[this.langConfig.curLang]['PLAY_EVENT'][childID-1]
      });

      this.tabData=tabData;
      this.$emit('onTabChange',tabData)
    },

     //获取屏幕宽度
     handleResize() {
      if(typeof window!='undefined'){
        this.isWeb=(window.innerWidth>767?true:false)
      }
    },
  },
  created() {
    this.getTabObj();
  },
  watch: {
    newTabData(val){
      if(val){
        this.getTabObj();
      }
    },
    isWeb(val){
      console.log(val)
      if(val == false){
        this.tabList[0].child[1].name = 'AH'
        this.tabList[0].child[2].name = 'O/U'
        this.tabList[0].child[3].name = 'Scores'
      }else{
        this.tabList[0].child[1].name = 'Asian Handicap'
        this.tabList[0].child[2].name = 'Goals Over/Under'
        this.tabList[0].child[3].name = 'Correct Scores'
      }
    },
    /* 1x2 （hasMargin true 或 hasDiff true 都可以显示），
      overuder 和 ah(hasDiff true 显示)， 
      后面两个（hasPoisson true 显示）*/
    hasData(val){
      console.log(JSON.stringify(val))
      if(val.hasMargin == false && val.hasDiff == false){
        this.tabList[0].child[0].isShow = false
      }
      if(val.hasDiff == false){
        this.tabList[0].child[1].isShow = false
        this.tabList[0].child[2].isShow = false
      }
      if(val.hasPoisson == false){
        console.log(this.tabList[0].child)
        this.tabList[0].child[3].isShow = false
        this.tabList[0].child[4].isShow = false
      }
    }
  },
  mounted() {
    
    setTimeout(() => {
      this.handleResize();
    },100)

    this.$nextTick(() => {
      if(typeof window!='undefined'){
        window.addEventListener('resize', this.handleResize);
      }
    })
  },
  beforeDestroy() {
    if(typeof window!='undefined'){
      window.removeEventListener('resize', this.handleResize);
    }
  },
  props: {
    newTabData: {
      type: Object,
      default:null
    }, 
    isHeadDown:{
      type: Boolean,
      default:false
    },

    //比赛信息
    match: {
      type: Object,
      default: null,
    },

    hasData: {
      type: Object,
      default:{
        hasMargin: true,
        hasPoisson: true,
        hasDiff: true,
      }
    }, 
  },
};
</script>



// WEBPACK FOOTER //
// ./src/views/details/components/detailsTab.vue